
import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { type SubscriptionFormValues } from "./SubscriptionFormSchema";
import { Star } from "lucide-react";

interface SubscriptionJokersFieldProps {
  control: Control<SubscriptionFormValues>;
}

export function SubscriptionJokersField({ control }: SubscriptionJokersFieldProps) {
  const { t } = useTranslation(["subscriptions", "common"]);

  return (
    <FormField
      control={control}
      name="jokersTotal"
      render={({ field }) => (
        <FormItem>
          <FormLabel className="flex items-center">
            <Star className="h-4 w-4 mr-2 text-purple-500" />
            {t('jokers.total')}
          </FormLabel>
          <FormControl>
            <Input
              type="number"
              min={0}
              {...field}
              onChange={(e) => field.onChange(Number(e.target.value))}
              className="transition-all focus-within:border-purple-500 focus-within:ring-purple-200"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
